export default {"src":"/_next/static/image/public/images/icons2/2.96dbb9fcda166cb06c2272aa9ada1cf3.svg","height":24,"width":24};